"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AmenityList_1 = __importDefault(require("../AmenityList"));
var SectionHeader_1 = __importDefault(require("../SectionHeader"));
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var SwimPoolFountainAmenity_1 = __importDefault(require("../DeveloperPostContent/DeveloperPostSections/BuildingProperties/AmenityList/SwimPoolFountainAmenity"));
var HomeStead_1 = __importDefault(require("../DeveloperPostContent/DeveloperPostSections/BuildingProperties/AmenityList/HomeStead"));
var PostDescription_1 = __importDefault(require("../PostDescription"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var BuildingInfoSection = function (_a) {
    var _b;
    var postData = _a.postData;
    var t = react_i18next_1.useTranslation('common').t;
    var buildingInfo = postData.sections.about_building;
    return (react_1.default.createElement("div", { className: "section-data" },
        buildingInfo.description ||
            buildingInfo.description_ru ||
            buildingInfo.description_en ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: styles_module_scss_1.default.about_building_header_section },
                react_1.default.createElement(SectionHeader_1.default, { title: t('POST_PREVIEW.BUILDING_INFO_DESCRIPTION') })),
            postData.building_name && (react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.building_name, 'text') },
                react_1.default.createElement("p", null, postData.building_name))),
            react_1.default.createElement(PostDescription_1.default, { postData: postData }))) : (react_1.default.createElement(react_1.default.Fragment, null)),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.about_building_header_section },
            react_1.default.createElement(SectionHeader_1.default, { title: t('POST_PREVIEW.BUILDING_INFO_PROPERTIES') })),
        ((_b = postData.sections.house_info) === null || _b === void 0 ? void 0 : _b.amenities) && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(AmenityList_1.default, { amenities: postData.sections.house_info.amenities }),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.bl_amenity_list },
                react_1.default.createElement(SwimPoolFountainAmenity_1.default, { swim_pool: postData.sections.about_building.swim_pool, fountain: postData.sections.about_building.fountain }),
                react_1.default.createElement(HomeStead_1.default, { homestead: postData.sections.about_building.homestead }))))));
};
exports.default = BuildingInfoSection;
